module.exports = __webpack_public_path__ + "img/2.72b95f33.png";